import { render, staticRenderFns } from "./UserInformationForm.vue?vue&type=template&id=161539cb&scoped=true"
import script from "./UserInformationForm.vue?vue&type=script&lang=js"
export * from "./UserInformationForm.vue?vue&type=script&lang=js"
import style0 from "./UserInformationForm.vue?vue&type=style&index=0&id=161539cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161539cb",
  null
  
)

export default component.exports